/*
 * ॐ नमः शिवाय
 *
 * Copyright (c) 2025 Rudra Coresoft Technologies Private Limited
 *
 * This software is licensed under the VIJAYA 1.0 License.
 * See the LICENSE file for the full text.
 */

/**
 * The route-or-venue model an activity type usually implies.
 *
 * `activity_type` carries its own `location_model` in the pack seed — RUN and
 * CYCLING are route-based, YOGA and SWIM are venue-based. The two columns stay
 * independent on purpose, though: a run held entirely inside a stadium is
 * venue-based, and an open-water swim follows a route. So this is a
 * SUGGESTION that pre-selects the choice, never a rule that makes it.
 *
 * Everything unknown resolves to ROUTE_BASED, which is `emptyActivity()`'s own
 * default — an activity's starting state is the same whether or not a type has
 * been picked yet.
 */

export const ROUTE_BASED = 'ROUTE_BASED';
export const VENUE_BASED = 'VENUE_BASED';

/** The only two values the column accepts. Anything else is not a model. */
const MODELS = [ROUTE_BASED, VENUE_BASED];

export function suggestedLocationModel(activityTypeId, activityTypes) {
  const rows = activityTypes?.rows;
  if (!Array.isArray(rows) || activityTypeId === '' || activityTypeId == null) {
    return ROUTE_BASED;
  }
  // Lookup ids arrive as numbers from the API and as strings from a <select>.
  const row = rows.find((entry) => String(entry?.id) === String(activityTypeId));
  const model = row?.location_model;
  return MODELS.includes(model) ? model : ROUTE_BASED;
}
